
export default {
  name: 'EducationMenuToggle',

  props: {
    selectedItem: {
      type: Object,
      required: true
    },

    activeMenuItemsLength: {
      type: Number,
      required: true
    }
  }
}
